"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const config_1 = require("../config/config");
const sdkError_1 = require("../errors/sdkError");
const error_1 = require("../helper/error");
const node_1 = require("../helper/node");
const refreshTokenManager_1 = require("../helper/refreshTokenManager");
const http_1 = require("../http");
class Client {
    constructor(params) {
        var _a;
        this.service = params.service;
        this.client = params.client || new http_1.AxiosClient();
        this.token = params.token ? params.token : config_1.config.getToken();
        this.region = this.getRegion(params);
        this.host = this.getHost(params);
        this.userAgent = params.userAgent;
        if (params.refreshTokenMethod) {
            this.refreshTokenManager = new refreshTokenManager_1.RefreshTokenManager(params.refreshTokenMethod);
            this.refreshTokenMethod = this.refreshTokenManager.getRefreshTokenMethod();
        }
        else if (config_1.config.getRefreshTokenMethod() && config_1.config.getRefreshTokenManager() !== undefined) {
            this.refreshTokenManager = config_1.config.getRefreshTokenManager();
            this.refreshTokenMethod = (_a = this.refreshTokenManager) === null || _a === void 0 ? void 0 : _a.getRefreshTokenMethod();
        }
    }
    getRegion(params) {
        const region = config_1.config.getRegion();
        if (params.type === 'global' && params.region) {
            throw new sdkError_1.InvalidRegionError('Invalid region: region ' + params.region + ' provided in constructor not available');
        }
        if (!params.host && params.type === 'regional' && !params.region && !region) {
            throw new sdkError_1.InvalidRegionOrHostError('Invalid region or host: no host or no region provided in constructor and no region configured in config');
        }
        if (params.type === 'global') {
            return 'global';
        }
        if (params.region && params.type === 'regional') {
            return params.region;
        }
        if (region && params.type === 'regional') {
            return region;
        }
        if (!params.host) {
            throw new sdkError_1.InvalidRegionError('Invalid region: no region provided in constructor and no region configured in config');
        }
    }
    getHost(params) {
        if (params.host) {
            return params.host;
        }
        const host = config_1.config.getHost(this.service, this.region);
        if (host) {
            return host;
        }
        throw new sdkError_1.InvalidHostError('Invalid host: no host provided in constructor and no host configured in config');
    }
    handle(request) {
        return new Promise((resolve, reject) => {
            if (!request.headers) {
                request.headers = {};
            }
            if ((0, node_1.isNode)()) {
                request.headers['User-Agent'] = this.userAgent;
            }
            request.headers = this.cleanHeaders(request.headers);
            this.client.handle(request).then(resolve).catch(reject);
        });
    }
    parseResponse(response, errors) {
        var _a;
        if (this.isValidStatusCode(response.statusCode)) {
            return response.body ? response.body : {};
        }
        else if (((_a = response === null || response === void 0 ? void 0 : response.body) === null || _a === void 0 ? void 0 : _a.name) && errors[(0, error_1.formatErrorName)((response === null || response === void 0 ? void 0 : response.body).name)]) {
            const body = response === null || response === void 0 ? void 0 : response.body;
            const error = new errors[(0, error_1.formatErrorName)((response === null || response === void 0 ? void 0 : response.body).name)](body);
            throw error;
        }
        else {
            throw new sdkError_1.UnknownError(response === null || response === void 0 ? void 0 : response.body);
        }
    }
    isValidStatusCode(code) {
        return code >= 200 && code < 300;
    }
    cleanHeaders(headers) {
        Object.keys(headers).forEach(key => headers[key] === undefined && delete headers[key]);
        return headers;
    }
}
exports.Client = Client;
